import { hdcBillUpcomingMock, hdcInfo } from "../builders/createInsuranceBill";
import { legacyUsSecondGearMember } from "../mockMembers";
import { getHdc1Dot0Membership } from "../builders/getHdc1Dot0Membership";
import { cigHdcUpcomingBill } from "../builders/createCigBill";
import { getMockPolicies } from "../builders/getMockPolicies";
import { MockPolicyId } from "../mockPolicies";

import { MockPersona } from "./mockPersonas.types";

const hdcLevel = 2;
const usPolicies: MockPolicyId[] = ["5R34843-01"];

export const deeReynolds: MockPersona = {
  key: "deeReynolds",
  name: "Dee Reynolds",
  description: "🇺🇸 | One core policy | HDC 1.0 Single-tier | Upcoming HDC Bill (no autopay)",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [cigHdcUpcomingBill("1.0", { id: "1" })],
      },
      policies: {
        usa: getMockPolicies(...usPolicies),
        canada: [],
      },
    },
    hdc: {
      fetch1Dot0Membership: getHdc1Dot0Membership({ ProductCode: "USMEMB2" }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "dee@reynolds.com",
            firstName: "Dee",
            middleName: "",
            lastName: "Reynolds",
            mailingAddress: {
              line1: "9241 Roosevelt Blvd",
              line2: "",
              city: "Philadelphia",
              state: "PA",
              postalCode: "19114",
              country: "USA",
            },
            preferredPhone: "2152098524",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000007",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyUsSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [hdcBillUpcomingMock({ id: "1" })],
          outstandingBalance: hdcInfo[hdcLevel - 1].cost,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
